import {AbstractApiService} from "./AbstractApiService";
import {API_SERVICE_URL} from "navigation-common/firebase-config";
import {EditorGroups} from "navigation-common/types/navigation-types";

class MenuSettingsService extends AbstractApiService {

    public async getEditorGroups(): Promise<EditorGroups> {
        const response = await this.client.get(API_SERVICE_URL + "/editorGroups", this.buildJWTAuthAxiosConfig());
        return response.data as EditorGroups;
    }

    public async setEditorGroups(editorGroups: EditorGroups): Promise<void> {
        await this.client.post(API_SERVICE_URL + "/editorGroups", editorGroups, this.buildJWTAuthAxiosConfig());
    }
}

export const menuSettingsService = new MenuSettingsService();
